import { render, staticRenderFns } from "./Tiempos.vue?vue&type=template&id=34c004d0&scoped=true&"
import script from "./Tiempos.vue?vue&type=script&lang=ts&"
export * from "./Tiempos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34c004d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('34c004d0', component.options)
    } else {
      api.reload('34c004d0', component.options)
    }
    module.hot.accept("./Tiempos.vue?vue&type=template&id=34c004d0&scoped=true&", function () {
      api.rerender('34c004d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/TorreControl/ControlConfiguracion/Configuraciones/Tiempos.vue"
export default component.exports